import axiosIns from 'utils/axios'
let epmcore ='EPM-CORE-SERVICE'

// 获取需求列表
export function progressEstimatepage (params) {
  return axiosIns({
    url: `/api/pc/progressEstimate/page`,
    owner: epmcore,
    method: 'get',
    params
  })
}

export function progressEstimateadd (data) {
  return axiosIns({
    url: `/api/pc/progressEstimate/add`,
    owner: epmcore,
    method: 'post',
    data
  })
}

export function progressEstimateupdate (data) {
  return axiosIns({
    url: `/api/pc/progressEstimate/update`,
    owner: epmcore,
    method: 'put',
    data
  })
}

export function progressEstimatenext (projectVersionId) {
  return axiosIns({
    url: `/api/pc/progressEstimate/next/${projectVersionId}`,
    owner: epmcore,
    method: 'get'
  })
}

export function progressEstimatedelete (projectVersionId) {
  return axiosIns({
    url: `/api/pc/progressEstimate/delete/${projectVersionId}`,
    owner: epmcore,
    method: 'delete'
  })
}






// WEBPACK FOOTER //
// ./src/views/project-manage/progress-estimate/api.js